import request from "@utils/request";

export function postOrderConfirm(cartId, type) {
  return request.post("/order/confirm", {
    cartId,
    type,
  });
}

// 将订单设置为已读
export function setOrderRead(params) {
  return request.get("/order/check", params);
}

export function postOrderComputed(key, data) {
  return request.post("/order/computed/" + key, data);
}

export function getOrderCoupon(cartId, type) {
  return request.get("/coupons/order/" + cartId, {
    type,
  });
}
export function getOrderCouponTemp(cartId, type, totalPrice, coachId) {
  return request.get("/coupons/orderTemp/" + cartId, {
    type,
    totalPrice,
    coachId,
  });
}

export function createOrder(key, data) {
  return request.post("/order/create/" + key, data || {});
}

export function getOrderData() {
  return request.get("/order/data");
}

export function getOrderList(data) {
  return request.get("/order/list", data);
}

export function cancelOrder(id) {
  return request.post("/order/cancel", {
    id,
  });
}

export function orderDetail(id, params) {
  return request.get("/order/detail/" + id, params);
}

export function getRefundReason() {
  return request.get("/order/refund/reason");
}

export function postOrderRefund(data) {
  return request.post("/order/refund/verify", data);
}

export function takeOrder(uni) {
  return request.post("/order/take", {
    uni,
  });
}

export function delOrder(uni) {
  return request.post("/order/del", {
    uni,
  });
}
export function delClient(uni,userDeleteType) {
  return request.post("/order/delClient", {
    uni,userDeleteType
  });
}

export function express(params) {
  return request.post("order/express", params);
}

export function payOrder(uni, paytype, from) {
  return request.post("order/pay", {
    uni,
    paytype,
    from,
  });
}

export function orderVerific(verifyCode, isConfirm) {
  return request.post("order/order_verific", {
    verifyCode,
    isConfirm,
  });
}
// 保存首次预约信息
export function orderFirstInfo(data) {
  return request.post("/reservation/sumbit", data);
}
// 首次预约信息
export function firstInfo(data) {
  return request.get("/reservation/getInfo", data);
}

// 首次预约信息
export function submitOrderHandle(data) {
  return request.post("/order/coachConfirm", data);
}
//确定订单来源
export function coachConfirmSource(data) {
  return request.post("/order/coachConfirmSource", data);
}
export function finishOrderHandle(data) {
  return request.post("/order/take", data);
}
export function coachOrderHandle(data) {
  return request.post("/order/coachInitiateConfirm", data);
}

// 邀请评价
export function inviteEvaluation(data) {
  return request.post("/order/invite_evaluation", data);
}
